import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

const PREFIX = 'PageHeader';

const classes = {
  header: `${PREFIX}-header`
};

const StyledTypography = styled(Typography)(({ theme }) => ({
  [`&.${classes.header}`]: {
    color: theme.palette.getContrastText(theme.palette.text.primary),
    display: 'inline-block'
  }
}));

interface PageHeaderProps {
  title?: string;
  icon?: string | JSX.Element;
}

const PageHeader = ({ title = '', icon = '' }: PageHeaderProps) => {
  return (
    <StyledTypography variant="h5" className={classes.header}>
      {typeof icon === 'object'
        ? React.cloneElement(icon, {
            style: { fontSize: '30px', marginRight: '16px' }
          })
        : null}
      <span data-testid="page-header-text" style={{ verticalAlign: 'top' }}>
        {title}
      </span>
    </StyledTypography>
  );
};

export default PageHeader;
